export const RaaRoles = {
  ADMIN: { id: 55100, displayName: 'Administrator' },
  PROVISIONER: { id: 55400, displayName: 'Provisioner' },
  MANAGER: { id: 55200, displayName: 'Manager' },
  BILLING: { id: 55500, displayName: 'Billing' },
  VIEWER: { id: 55300, displayName: 'Viewer' },
};

export const sessionUserHasRolePrivileges = (
  activeSubscription, targetRoleList,
) => {
  if (!activeSubscription
    || !activeSubscription.role
    || !activeSubscription.role.id
  ) {
    return false;
  }

  const userRoleId = activeSubscription.role.id;

  const targetRoleIdList = targetRoleList.map((role) => role.id);
  return targetRoleIdList.includes(userRoleId);
};
